import { Box, Text } from "@nulogy/components";
import { formatDuration } from "components/helpers/format";
import React from "react";

const renderTimeRemainingMessage = (remainingDurationInSeconds) => {
  if (!Number.isFinite(remainingDurationInSeconds))
    return "Remaining duration cannot be calculated with a production rate of 0.";

  const timeRemaining = formatDuration(remainingDurationInSeconds);
  const prefix = remainingDurationInSeconds < 0 ? "Overscheduled by" : "To be scheduled";

  return (
    <>
      <Text color="midGrey" fontSize="smaller" inline lineHeight="smallerText">
        {prefix}:{" "}
      </Text>
      <Text fontSize="smaller" fontWeight="medium" inline lineHeight="smallerText">
        {timeRemaining}
      </Text>
    </>
  );
};

export default function RemainingDuration({ remainingDurationInSeconds }) {
  return (
    <Box data-testid="remaining-duration" fontSize="smaller" lineHeight="smallerText">
      {renderTimeRemainingMessage(remainingDurationInSeconds)}
    </Box>
  );
}
